var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pfHrefInfo)?_c('v-btn',{staticClass:"svg-icon",style:(`width:${_vm.btnWidth}px;height:${_vm.btnHeight}px`),attrs:{"icon":""},on:{"click":function($event){_vm.openInNewTab(_vm.getClientRefFromParsed(_vm.pfHrefInfo))}}},[_c('v-icon',{attrs:{"size":_vm.size,"color":"mainNew"}},[_vm._v(_vm._s('$vuetify.icons.profSalon'))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }